import React, { useState, useEffect, createElement, useImperativeHandle } from 'react';
import { Dialog } from '@alifd/next';
const CbayelDialog = (props, ref) => {
    const { children, ...restProps } = props;
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const { visible = false } = props;
        setVisible(visible);
    }, []);
    const open = () => {
        setVisible(true);
    };
    const show = () => {
        setVisible(true);
    };
    const close = () => {
        setVisible(false);
    };
    const hidden = () => {
        setVisible(false);
    };
    const onOk = (event) => {
        const { onOk } = props;
        if (isValidFunction(onOk)) {
            onOk(event);
        }
        if (!('visible' in props)) {
            setVisible(false);
        }
    };
    const onCancel = (event) => {
        const { onCancel } = props;
        if (isValidFunction(onCancel)) {
            onCancel(event);
        }
        setVisible(false);
    };
    const onClose = (trigger, event) => {
        const { onClose } = props;
        if (isValidFunction(onClose)) {
            onClose(trigger, event);
        }
        setVisible(false);
    };
    useImperativeHandle(ref, () => ({ open, show, close, hidden }));
    return (createElement(Dialog, { ...restProps, v2: true, ref: ref, visible: visible, onOk: onOk, onCancel: onCancel, onClose: onClose }, children));
};
export const DialogRef = React.forwardRef(CbayelDialog);
export default DialogRef;
const isValidFunction = (func) => typeof func === 'function';
